module.exports = __webpack_public_path__ + "static/media/hamamo_only_logo_baydiamond.a54341c9.png";